<template>
    <div class='txxsc box' v-if='!isLoading'>
        <table class="list" v-loading="waitLoading">
            <col style="width:150px"/>
            <col style="width:160px"/>
            <col style="width:160px"/>
            <col style="width:140px"/>
            <thead>
                <tr>
                    <td v-if="showSign">是否签到</td>
                    <td>是否上传投标文件</td>
                    <td v-if='scfs=="2"'>是否缴纳投标保证金</td>
                    <td>审查结果</td>
                    <td>审查意见</td>
                    <td style="width: 90px" v-if="showCqbh">抽签编号</td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <template v-if='tbdw.id'>
                        <td v-if="showSign" v-html="tbdw.sfqd=='0'?'<span class=\'red\'>否</span>':'<span class=\'success\'>是</span>'"></td>
                        <td v-html="tbdw.fbyjdzbs=='0'?'<span class=\'red\'>否</span>':'<span class=\'success\'>是</span>'"></td>
                        <td v-if='scfs=="2"' v-html="tbdw.sfjnbzj=='0'?'<span class=\'red\'>否</span>':'<span class=\'success\'>是</span>'"></td>
                        <td v-html="tbdw.kbsczt=='2'?'<span class=\'red\'>未通过</span>':'<span class=\'success\'>已通过</span>'"></td>
                        <td>{{tbdw.bz}}</td>
                        <td style="width: 90px" v-if="showCqbh">{{tbdw.cqbh ? tbdw.cqbh : '待生成'}}</td>
                    </template>
                    <template v-else>
                        <td v-if="showSign"></td>
                        <td></td>
                        <td v-if='scfs=="2"'></td>
                        <td></td>
                        <td></td>
                        <td style="width: 90px" v-if="showCqbh"></td>
                    </template>
                </tr>
            </tbody>
        </table>
    </div>
    <div v-else class='loading'>
        <p>正在进行有效性审查，请耐心等待...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
    export default {
        name:'tbyxxsc',
        props:['djlcId'],
        data(){
            return{
                waitLoading: false,
                tbdw:{},
                scfs:'1',
                isLoading:true,
                showSign: true,
                showCqbh: false,
                zbxmkpfs: sessionStorage.getItem("zbxmkpfs")
            }
        },
        methods:{
            getData(){
                let para={
                    djlcId:this.djlcId
                }
                this.waitLoading = true
                this.$api.yxxscTbr(para).then(res=>{
                    if(res.data.meta.success){
                        if(res.data.data.tbdw.kbsczt!='0'){
                            this.tbdw=res.data.data.tbdw;
                            this.scfs=res.data.data.kbxm.scfs
                            this.showCqbh=res.data.data.kbxm.showCqbh
                        }
                        this.showSign=this.zbxmkpfs!=9&&this.zbxmkpfs!=10
                        this.isLoading=false
                        this.waitLoading = false
                    }else{
                        this.$message({
                            type:'error',
                            message:res.data.meta.message
                        })
                        this.isLoading=false
                        this.waitLoading = false
                    }
                }).catch(()=>{})
            },
        },
        mounted(){
            this.getData();
        }
    }
</script>
